module.exports = __webpack_public_path__ + "img/Feature.bd7a2352.png";